/* Product page extras (Oct 1 2026). Loaded from snippets/thera-notify-popup.liquid on product pages. */

/* Review fit answers (Oct 1 2026): Judge.me now asks buyers how the product fits and how the weight
   feels. The theme rebuilds Judge.me's reviews into its own cards and dropped those answers, so they
   are read from Judge.me's hidden copy and added under the matching review's text. */
(function () {
  var FIT = { 1: 'Runs small', 2: 'Runs a little small', 3: 'True to size', 4: 'Runs a little large', 5: 'Runs large' };
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 60); }
  function answers(item) {
    var out = [];
    var f = item.querySelector('.jm-custom-answer-list__item');
    if (f) {
      var m = f.textContent.match(/(\d)\s*\/\s*5/);
      var n = m ? +m[1] : 0;
      if (!n) { var bar = f.querySelector('.jm-progress-bar__fill'); var w = bar && parseFloat(bar.style.width); if (w) n = Math.round(w / 20); }
      if (FIT[n]) out.push('<span><b>Fit:</b> ' + FIT[n] + '</span>');
    }
    item.querySelectorAll('.jm-multi-choice-answer').forEach(function (mc) {
      var label = mc.firstElementChild && mc.firstElementChild.textContent.trim().toLowerCase();
      if (label !== 'weight') return;
      var vals = Array.prototype.map.call(mc.querySelectorAll('.jm-answer-item'), function (a) { return a.textContent.trim(); }).filter(Boolean);
      if (vals.length) out.push('<span><b>Weight:</b> ' + vals.join(', ') + '</span>');
    });
    return out;
  }
  function run() {
    var src = document.querySelector('[data-rv-jmsource]');
    var list = document.querySelector('[data-rv-jmlist]');
    if (!src || !list) return;
    var items = [];
    src.querySelectorAll('.jm-review-item').forEach(function (it) {
      var a = answers(it);
      if (a.length) items.push({ text: (it.textContent || '').replace(/\s+/g, ' ').toLowerCase(), a: a });
    });
    if (!items.length) return;
    list.querySelectorAll('.thera-rv__review').forEach(function (card) {
      if (card.querySelector('.thera-rv__fit')) return;
      var t = card.querySelector('[data-rv-text]');
      var key = t && norm(t.textContent);
      if (!key || key.length < 12) return;
      var hit = items.filter(function (x) { return x.text.indexOf(key) !== -1; })[0];
      if (!hit) return;
      var a = hit.a;
      var p = document.createElement('p');
      p.className = 'thera-rv__fit';
      p.innerHTML = a.join('<span class="thera-rv__fit-sep" aria-hidden="true">·</span>');
      (card.querySelector('.thera-rv__content-text') || t.parentNode).appendChild(p);
    });
  }
  var t = null;
  function schedule() { if (!t) t = setTimeout(function () { t = null; run(); }, 50); }
  function start() {
    run();
    var list = document.querySelector('[data-rv-jmlist]');
    var src = document.querySelector('[data-rv-jmsource]');
    var mo = new MutationObserver(schedule);
    if (list) mo.observe(list, { childList: true, subtree: true });
    if (src) mo.observe(src, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* Sold-out colour + size combination (Oct 7 2026, Klara/Liam). The Oct 1 version crossed out every
   colour circle that was sold out in the chosen size, which read as "this whole colour is sold out".
   Colour circles now always look normal (a colour that is sold out in EVERY size is still dimmed by
   the section itself). Sizes carry the sold-out signal: the section already strikes through the sizes
   that are sold out in the chosen colour. When the shopper's colour + size combination is sold out, a
   short line under the options says so, next to the Notify Me button. */
(function () {
  function run() {
    var form = document.querySelector('form.tmp__form');
    var vEl = document.querySelector('[data-tmp-variants]');
    if (!form || !vEl) return;
    var variants; try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
    var sel = [], colourPos = 0, sizePos = 0;
    document.querySelectorAll('[data-tmp-opt]').forEach(function (g) {
      var pos = parseInt(g.getAttribute('data-tmp-opt'), 10);
      var a = g.querySelector('.is-active');
      sel[pos - 1] = a ? a.getAttribute('data-tmp-val') : null;
      if (g.querySelector('.tmp__swatch')) colourPos = pos;
      if (g.querySelector('.tmp__opt')) sizePos = pos;
    });
    // Clear the old Oct 1 markings in case a cached page still applies them.
    document.querySelectorAll('.tmp__swatch.thera-size-oos').forEach(function (b) {
      b.classList.remove('thera-size-oos');
      if (/ is sold out in /.test(b.getAttribute('title') || '')) b.removeAttribute('title');
    });
    var sizeGroup = sizePos ? document.querySelector('[data-tmp-opt="' + sizePos + '"]') : null;
    if (!sizeGroup) return;
    var note = document.querySelector('[data-thera-combo-note]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'thera-combo-note';
      note.setAttribute('data-thera-combo-note', '');
      note.setAttribute('role', 'status');
      note.hidden = true;
      sizeGroup.insertAdjacentElement('afterend', note);
    }
    var colour = colourPos ? sel[colourPos - 1] : null;
    var size = sel[sizePos - 1];
    var msg = '';
    if (colour && size) {
      var m = variants.filter(function (v) { return sel.every(function (pv, i) { return pv == null || v.options[i] === pv; }); });
      if (m.length && !m.some(function (v) { return v.available; })) {
        msg = colour + ' is sold out in ' + size + '. Choose another size, or tap Notify Me to hear when it’s back.';
      }
    }
    note.textContent = msg;
    note.hidden = !msg;
  }
  function start() { run(); setTimeout(run, 300); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-tmp-opt]')) { setTimeout(run, 60); setTimeout(run, 250); }
  });
})();

/* Kaching A/B test: bundle cards follow the variant the shopper gets (Oct 1 2026).
   The theme's third bundle card is set up as Hoodie + Robe. When Kaching serves the test variant
   (Single / Double / Trio), that card was relabelled "Trio" and priced for 3 hoodies, but it still
   showed — and added to the cart — 1 hoodie + 1 robe. For a quantity offer, the card now shows one
   hoodie picker per unit (3 for a Trio) and leaves out the robe; for the Hoodie & Robe offer it is
   unchanged. */
(function () {
  function findBar(id) {
    if (!id) return null;
    var scripts = document.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent;
      if (!t || t.indexOf('dealBars') === -1 || t.indexOf(id) === -1) continue;
      try {
        var j = JSON.parse(t);
        for (var k = 0; j && j.dealBars && k < j.dealBars.length; k++) if (j.dealBars[k] && j.dealBars[k].id === id) return j.dealBars[k];
      } catch (e) {}
    }
    return null;
  }
  function copySelects(from, to) {
    var a = from.querySelectorAll('select'), b = to.querySelectorAll('select');
    for (var i = 0; i < a.length && i < b.length; i++) b[i].value = a[i].value;
  }
  function fix() {
    document.querySelectorAll('.tmp__bundle[data-kbar]').forEach(function (card) {
      var bar = findBar(card.getAttribute('data-kbar'));
      var conf = card.querySelector('.tmp__bundle-config');
      if (!bar || !conf) return;
      var isQty = card.getAttribute('data-ktype') !== 'bundle' && !(bar.bundleProducts && bar.bundleProducts.length);
      conf.querySelectorAll('.tmp__bitem:not([data-bitem-main])').forEach(function (el) {
        if (isQty && el.hasAttribute('data-bitem')) {
          el.removeAttribute('data-bitem'); el.setAttribute('data-thera-off', ''); el.style.display = 'none';
        } else if (!isQty && el.hasAttribute('data-thera-off')) {
          el.removeAttribute('data-thera-off'); el.setAttribute('data-bitem', ''); el.style.display = '';
        }
      });
      if (!isQty) {
        conf.querySelectorAll('[data-thera-clone]').forEach(function (e) { e.remove(); });
      } else {
        var want = Math.max(1, parseInt(bar.quantity, 10) || 1);
        var mains = conf.querySelectorAll('[data-bitem-main]');
        while (mains.length < want) {
          var last = mains[mains.length - 1];
          var cl = last.cloneNode(true);
          cl.setAttribute('data-thera-clone', '');
          copySelects(last, cl);
          last.parentNode.insertBefore(cl, last.nextSibling);
          mains = conf.querySelectorAll('[data-bitem-main]');
        }
        while (mains.length > want) {
          var clones = conf.querySelectorAll('[data-bitem-main][data-thera-clone]');
          (clones.length ? clones[clones.length - 1] : mains[mains.length - 1]).remove();
          mains = conf.querySelectorAll('[data-bitem-main]');
        }
      }
      var n = String(conf.querySelectorAll('[data-bitem-main]').length);
      if (card.getAttribute('data-main-qty') !== n) card.setAttribute('data-main-qty', n);
    });
  }
  function start() {
    var el = document.querySelector('[data-tmp-bundles]');
    if (!el) return;
    fix();
    new MutationObserver(fix).observe(el, { subtree: true, attributes: true, attributeFilter: ['data-kbar', 'data-ktype'] });
    var n = 0, iv = setInterval(function () { fix(); if (++n > 30) clearInterval(iv); }, 500);
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
